import { fetchFactory } from '../../../utils/fetchFactory'

export const me = async (accessToken: any) => fetchFactory('/api/users/me', {
    method: 'POST',
    body: JSON.stringify(accessToken)
})